import { Route, Navigate } from "react-router-dom";
import Dashboard from "@pages/dashboard";

export const dashboardRoutes = [
  <Route key="dashboard" path="/dashboard" element={<Dashboard />} />,
  <Route key="root" path="/" element={<Navigate to="/dashboard" replace />} />,
];
